// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"c1f5120c","513":"3849d298","703":"7b320fa6","787":"ca822a80"}[chunkId] + ".chunk.js";
};